// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2bonT","checkbox":"styles-module__checkbox___BjmhG","ambiguous":"styles-module__ambiguous___87tYN"};